import {
  BulbOutlined,
  CodeOutlined,
  DatabaseOutlined,
  GlobalOutlined,
  CloudOutlined,
  KeyOutlined,
  ApiOutlined,
  RobotOutlined,
  AppstoreOutlined,
  ToolOutlined,
  StarOutlined,
  ThunderboltOutlined,
  NotificationOutlined,
  BookOutlined,
  MessageOutlined,
  FileTextOutlined,
  ExperimentOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  LineChartOutlined
} from '@ant-design/icons';

/**
 * AI 工具卡片可选图标（key 与 antd 图标的 data-icon 一致，便于识别）
 * key 存入 fxz_agent_info.agent_icon；空 key 表示按名称/类型自动选择
 */
export const AGENT_ICON_OPTIONS = [
  { key: 'bulb', label: '灯泡', Icon: BulbOutlined },
  { key: 'key', label: '密钥', Icon: KeyOutlined },
  { key: 'api', label: '接口', Icon: ApiOutlined },
  { key: 'database', label: '数据库', Icon: DatabaseOutlined },
  { key: 'code', label: '代码', Icon: CodeOutlined },
  { key: 'global', label: '全球', Icon: GlobalOutlined },
  { key: 'cloud', label: '云', Icon: CloudOutlined },
  { key: 'robot', label: '机器人', Icon: RobotOutlined },
  { key: 'appstore', label: '应用', Icon: AppstoreOutlined },
  { key: 'tool', label: '工具', Icon: ToolOutlined },
  { key: 'star', label: '星标', Icon: StarOutlined },
  { key: 'thunderbolt', label: '闪电', Icon: ThunderboltOutlined },
  { key: 'notification', label: '通知', Icon: NotificationOutlined },
  { key: 'book', label: '手册', Icon: BookOutlined },
  { key: 'message', label: '消息', Icon: MessageOutlined },
  { key: 'file-text', label: '文档', Icon: FileTextOutlined },
  { key: 'experiment', label: '实验', Icon: ExperimentOutlined },
  { key: 'safety-certificate', label: '安全', Icon: SafetyCertificateOutlined },
  { key: 'team', label: '团队', Icon: TeamOutlined },
  { key: 'line-chart', label: '图表', Icon: LineChartOutlined }
];

/** icon key -> 组件 映射 */
export const AGENT_ICON_MAP = AGENT_ICON_OPTIONS.reduce((acc, item) => {
  acc[item.key] = item.Icon;
  return acc;
}, {});

/**
 * 解析工具卡片图标组件
 * 优先使用管理员配置的 agent_icon；未配置或未知 key 时返回 null（由调用方回退到自动逻辑）
 */
export const resolveAgentIcon = (iconKey) => {
  if (!iconKey) return null;
  return AGENT_ICON_MAP[String(iconKey)] || null;
};

/**
 * 构造 antd Select 的图标选项（label 带图标预览）
 */
export const getAgentIconSelectOptions = () => [
  { value: '', label: '自动（按名称/类型）' },
  ...AGENT_ICON_OPTIONS.map(({ key, label, Icon }) => ({
    value: key,
    label: (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <Icon />
        {label}
        <span style={{ color: '#999', fontSize: 12 }}>({key})</span>
      </span>
    )
  }))
];
